import type { ApiClient } from "@/lib/api";

export const deleteUserSource = async ({
  client,
  userSourceId,
}: {
  client: ApiClient;
  userSourceId: string;
}) => {
  await client.delete(`/user_sources/${encodeURIComponent(userSourceId)}`);
};
